<nav class="w-full sticky top-0 flex justify-between items-center px-8 pt-4 bg-white z-[10]">
  <div class="flex gap-4">
    <button (click)="asideService.openMobileMenu();asideService.setFullMenu()" class="flex md:hidden flex-row gap-x-1">
      <img (click)="asideService.setFullMenu()" class="h-8 transition duration-300 mb-4" src="assets/img/logo-a-red.svg" alt="Logo alonso min">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 text-dark mt-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M4 6l16 0" /><path d="M4 12l16 0" /><path d="M4 18l16 0" />
      </svg>
    </button>
    <div class="flex items-center gap-0 animate-fade-in" *ngIf="breadcrumbs">
      <ng-container *ngFor="let item of breadcrumbs.items; let last = last">
        <a *ngIf="!last && item.url" [routerLink]="item.url" class="text-sm text-gray-500 hover:text-primary duration-200">{{ item.name }}</a>
        <span *ngIf="!last && !item.url" class="text-sm text-gray-500">{{ item.name }}</span>
        <span *ngIf="!last" class="text-sm text-gray-300 mx-1.5">/</span>
        <span *ngIf="last" class="text-sm font-medium text-dark">{{ item.name }}</span>
      </ng-container>
    </div>
  </div>

  <div class="flex items-center justify-end gap-4" *ngIf="user">
    <!-- Alertas de vehículos (ITV) - Admin y profesores -->
    <div *ngIf="vehicleAlertCount > 0" class="relative vehicle-alerts-dropdown">
      <button
        (click)="toggleVehicleAlertsDropdown($event)"
        class="relative p-2 text-gray-600 hover:text-gray-800 transition-colors"
        [attr.aria-label]="'Alertas de vehículos (' + vehicleAlertCount + ')'"
      >
        <!-- Icono de coche con alerta -->
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
        </svg>

        <!-- Badge con contador -->
        <span
          *ngIf="vehicleAlertCount > 0"
          class="absolute top-0 right-0 inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white rounded-full"
          [ngClass]="vehicleAlerts[0]?.priority === 'overdue' ? 'bg-red-600 animate-pulse' : 'bg-amber-500'"
        >
          {{ vehicleAlertCount > 99 ? '99+' : vehicleAlertCount }}
        </span>
      </button>

      <!-- Dropdown de alertas de vehículos -->
      <div
        *ngIf="isVehicleAlertsDropdownOpen"
        class="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-xl ring-1 ring-black ring-opacity-5 animate-slide-in-top z-50 max-h-[28rem] overflow-hidden flex flex-col"
      >
        <!-- Header -->
        <div class="px-4 py-3 border-b border-gray-200 flex items-center justify-between bg-gray-50">
          <h3 class="text-sm font-semibold text-gray-900">
            Alertas de vehiculos ({{ vehicleAlertCount }})
          </h3>
          <span class="text-[10px] text-gray-400 uppercase font-medium">ITV</span>
        </div>

        <!-- Lista de alertas -->
        <div class="overflow-y-auto flex-1">
          <!-- Sin alertas -->
          <div
            *ngIf="vehicleAlerts.length === 0"
            class="px-4 py-8 text-center text-gray-500 text-sm"
          >
            <svg class="w-12 h-12 mx-auto mb-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p>Todos los vehiculos tienen la ITV en regla</p>
          </div>

          <!-- Alertas -->
          <div
            *ngFor="let alert of vehicleAlerts"
            (click)="navigateToVehicle(alert)"
            class="border-b border-gray-100 px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors"
          >
            <div class="flex items-start gap-3">
              <!-- Icono de urgencia -->
              <div class="flex-shrink-0 mt-0.5">
                <div class="w-8 h-8 rounded-full flex items-center justify-center"
                  [ngClass]="{
                    'bg-red-100': alert.priority === 'overdue',
                    'bg-amber-100': alert.priority === 'urgent',
                    'bg-green-100': alert.priority === 'upcoming'
                  }">
                  <svg *ngIf="alert.priority === 'overdue'" class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                  <svg *ngIf="alert.priority === 'urgent'" class="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  <svg *ngIf="alert.priority === 'upcoming'" class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
              </div>

              <!-- Contenido -->
              <div class="flex-1 min-w-0">
                <div class="flex items-center gap-2 mb-0.5">
                  <span class="text-[10px] font-semibold uppercase px-1.5 py-0.5 rounded"
                    [ngClass]="getAlertBadgeClasses(alert.priority)">
                    {{ getAlertBadgeLabel(alert.priority) }}
                  </span>
                </div>
                <p class="text-sm font-semibold text-gray-900 truncate">{{ alert.title }}</p>
                <p class="text-xs text-gray-600 mt-0.5">{{ alert.message }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Notificaciones (Solo para profesores) -->
    <div *ngIf="isTeacher" class="relative notifications-dropdown">
      <button
        (click)="toggleNotificationsDropdown($event)"
        class="relative p-2 text-gray-600 hover:text-gray-800 transition-colors"
        [attr.aria-label]="'Notificaciones (' + unreadCount + ' sin leer)'"
      >
        <!-- Icono de campana -->
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>

        <!-- Badge con contador y animación -->
        <span
          *ngIf="unreadCount > 0"
          class="absolute top-0 right-0 inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-600 rounded-full animate-pulse"
        >
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>
      </button>

      <!-- Dropdown de notificaciones -->
      <div
        *ngIf="isNotificationsDropdownOpen"
        class="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-xl ring-1 ring-black ring-opacity-5 animate-slide-in-top z-50 max-h-[32rem] overflow-hidden flex flex-col"
      >
        <!-- Header del dropdown -->
        <div class="px-4 py-3 border-b border-gray-200 flex items-center justify-between bg-gray-50">
          <h3 class="text-sm font-semibold text-gray-900">
            Notificaciones ({{ unreadCount }})
          </h3>
          <button
            *ngIf="unreadCount > 0"
            (click)="markAllAsRead($event)"
            class="text-xs text-red-600 hover:text-red-800 font-medium"
          >
            Marcar todas como leídas
          </button>
        </div>

        <!-- Lista de notificaciones -->
        <div class="overflow-y-auto flex-1">
          <!-- Sin notificaciones -->
          <div
            *ngIf="notifications.length === 0"
            class="px-4 py-8 text-center text-gray-500 text-sm"
          >
            <svg class="w-12 h-12 mx-auto mb-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p>No tienes notificaciones pendientes</p>
          </div>

          <!-- Notificaciones -->
          <div
            *ngFor="let notification of notifications"
            class="border-b border-gray-100 transition-all duration-300"
            [class.opacity-0]="dismissingNotificationId === notification.id"
            [class.translate-x-4]="dismissingNotificationId === notification.id"
            [class.scale-95]="dismissingNotificationId === notification.id"
          >
            <div class="px-4 py-3">
              <div class="flex items-start gap-3">
                <!-- Contenido -->
                <div class="flex-1 min-w-0">
                  <!-- Badge de tipo -->
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-[10px] font-semibold uppercase px-1.5 py-0.5 rounded"
                      [class]="getActionTypeColor(notification.action_type)">
                      {{ getActionTypeLabel(notification.action_type) }}
                    </span>
                  </div>

                  <!-- Título -->
                  <p class="text-sm font-semibold text-gray-900 truncate">
                    {{ notification.title }}
                  </p>

                  <!-- Descripción -->
                  <p class="text-xs text-gray-600 line-clamp-2 mt-1">
                    {{ notification.description }}
                  </p>

                  <!-- Timestamp -->
                  <p class="text-xs text-gray-400 mt-1 mb-2">
                    {{ getTimeSince(notification.created_at) }}
                  </p>

                  <!-- Botón Marcar como hecha -->
                  <button
                    (click)="markAsReadAndNavigate(notification, $event)"
                    class="mt-2 px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-xs font-medium rounded transition-all duration-200"
                    [class.bg-green-600]="dismissingNotificationId === notification.id"
                    [class.scale-95]="dismissingNotificationId === notification.id"
                    [disabled]="dismissingNotificationId === notification.id"
                  >
                    <span *ngIf="dismissingNotificationId !== notification.id">Marcar como hecha</span>
                    <span *ngIf="dismissingNotificationId === notification.id" class="flex items-center gap-1">
                      <svg class="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Marcando...
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Contenedor del menú desplegable -->
    <div class="relative">
      <!-- Botón que activa el menú -->
      <div class="flex flex-row gap-x-2 items-center cursor-pointer" (click)="toggleDropdown($event)">
        <span class="font-bold text-dark animate-fade-in">{{ user.profile.name }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M6 9l6 6l6 -6" />
        </svg>
      </div>
  
      <!-- Menú desplegable -->
      <div *ngIf="isDropdownOpen" class="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 animate-slide-in-top">
        <div class="flex flex-col p-2"> 
          <button (click)="logOut()" class="duration-300 w-full flex flex-row items-center gap-x-2 p-2 text-sm rounded text-dark hover:bg-gray-100">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
              <path d="M9 12h12l-3 -3" />
              <path d="M18 15l3 -3" />
            </svg>
            <p class="text-dark font-semibold">Cerrar sesión</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>

<!-- Modal de confirmación: Marcar todas como leídas -->
<app-confirmation
  *ngIf="showMarkAllConfirmation"
  [visible]="showMarkAllConfirmation"
  question="¿Estás seguro de que quieres marcar todas las notificaciones como leídas?"
  confirmText="Sí, marcar todas"
  cancelText="Cancelar"
  (confirm)="confirmMarkAllAsRead()"
  (cancel)="cancelMarkAllAsRead()"
>
</app-confirmation>
